/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function TokenIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "token", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("circle", { cx: 12.5, cy: 12.5, r: 8, stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M17.5711 12.5C17.5711 15.2614 15.3325 17.5 12.5711 17.5M7.57107 12.5C7.57107 9.73858 9.80964 7.5 12.5711 7.5", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(TokenIcon);
export default ForwardRef;
//# sourceMappingURL=tokenIcon.js.map